/*
 * Authors: mariushirjanu
 * Created: 06/09/2022
 */
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { GaFormlyService, IExtraFieldConfigurationObject } from '../../../shared/formly/ga-formly.service';
import { GaValidateService } from '../../../shared/formly/ga-validate.service';
import { BUTTON_SAVE, DefaultFormDialogComponent } from '../../../shared/message/dialogs/default-form-dialog.component';
import { TranslationService } from '../../../shared/translation/translation.service';
import { IOrderCancelOption, OrderEntryDataService } from './order-entry-data.service';
import { FormattingService } from '../../../shared/services/formatting.service';

interface IOrderEntryCancelDialogModel {
  option:IOrderCancelOption;
  comment:string;
}

@Component({
  selector: 'order-entry-cancel-dialog',
  templateUrl: '../../../shared/message/dialogs/default-form-dialog.html'
})
export class OrderEntryCancelDialogComponent extends DefaultFormDialogComponent implements OnInit {
  @Input() public orderId:number;
  @Input() public sendMail:boolean;
  @Output() public onClose:EventEmitter<void> = new EventEmitter();
  @Output() public onOrderCancelled:EventEmitter<void> = new EventEmitter();

  public closeButton:boolean = false;
  public error:string;
  public model:IOrderEntryCancelDialogModel = <any>{};
  private reasonRadioField:IExtraFieldConfigurationObject;

  constructor(
    private formlyService:GaFormlyService,
    validateService:GaValidateService,
    translationService:TranslationService,
    private orderDataService:OrderEntryDataService,
    private formattingService:FormattingService
  ) {
    super(validateService, translationService);
  }

  public ngOnInit():void {
    super.ngOnInit();

    // for this dialog the cancel button is inverted -> red CANCEL button acts as cancelling order while the green button is for closing the dialog
    this.buttons = [ {
      label: 'ORDERENTRY.CANCEL.CONTINUE',
      className: 'btn btn-success',
      onClick: () => this.onClose.emit()
    }, {
      id: BUTTON_SAVE,
      label: 'ORDERENTRY.CANCEL.CANCEL',
      className: 'btn btn-danger',
      onClick: this.cancelOrder
    } ];

    this.start();
  }

  private start():void {
    this.fields = this.createFields();

    this.loading = true;
    this.formlyService.fillField(this.reasonRadioField, this.orderDataService.cancelOptions(this.orderId))
      .finally(() => {
        this.loading = false;
      });
  }

  private createFields():IExtraFieldConfigurationObject[] {
    const labelClass:string = 'col-md-12';
    const valueClass:string = 'col-md-12';

    return [
      this.formlyService.aTemplate(`<p>${this.translationService.instant('ORDERENTRY.CANCEL.SURE')}</p>`)
        .build(),

      this.reasonRadioField = this.formlyService.aRadio('option', 'ORDERENTRY.CANCEL.SELECT_REASON')
      .isRequired()
      .withFormat(this.formattingService.formatLov)
      .withLabelClass(`${labelClass} col-space-bottom`)
      .withValueClass(valueClass)
      .build(),

    this.formlyService.aTextarea('comment', 'ORDERENTRY.CANCEL.WHY')
      .isRequired()
      .withLabelClass(labelClass)
      .withValueClass(valueClass)
      .build()
    ];
  }

  public cancelOrder = ():void => {
    this.validateService.validateFields(this.fields, this.model, true)
      .then(() => {
        this.saveButtonBusy = true;
        return this.orderDataService.cancelOrder(this.orderId, this.model.option.id, this.model.comment, !this.sendMail);
      })
      .then(() => {
        this.onOrderCancelled.emit();
      })
      .finally(() => {
        this.saveButtonBusy = false;
      });
  };
}